import axios from 'axios';
import React, { useEffect, useState } from 'react';


  import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Pagination } from 'swiper/modules';


  const today = new Date()
  const weekday = today.toLocaleDateString('en-US', { weekday: 'long' });
  const month = today.toLocaleDateString('en-US', {month: 'long'})
  const day = today.toLocaleDateString('en-US', {day : '2-digit'})
  const year = today.getFullYear()
  const formattedDate = `${weekday}, ${month}, ${day}, ${year}`



const zodiacData = [
  {
    date: {formattedDate},
    sign: 'Scorpio',
    image: 'uploads/scorpio.jpeg',
    description: 'Ganesha says today will be full of enthusiasm and energy...'
  },
  {
    date: {formattedDate},
    sign: 'Leo',
    image: 'uploads/leo.jpg',
    description: 'Your energy will influence others positively.'
  },
  {
    date: {formattedDate},
    sign: 'Gemini',
    image: 'uploads/gemini.jpg',
    description: 'Be careful with financial decisions today.'
  }
];

const galleryImages = [
  'src/images/gallery1-image1.webp',
  'src/images/gallery1-image2.webp',
  'src/images/gallery1-image3.webp',
  'src/images/gallery1-image4.webp',
  'src/images/gallery1-image5.webp',
  'src/images/gallery1-image6.webp',
];

const menuItems = [
  { icon: 'src/images/topnews.webp', text: 'Top News', link: '#' },
  { icon: 'src/images/health.webp', text: 'Health', link: '#' },
  { icon: 'src/images/op-ed.webp', text: 'OP-ED', link: '#' },
  { icon: 'src/images/education.webp', text: 'Education', link: '#' },
  { icon: 'src/images/world.webp', text: 'World', link: '#' },
  { icon: 'src/images/bollywood.webp', text: 'Bollywood', link: '#' },
  { icon: 'src/images/entertainment.webp', text: 'Entertainment', link: '#' },
  { icon: 'src/images/business.webp', text: 'Business', link: '#' },
  { icon: 'src/images/glamour.webp', text: 'Glamour', link: '#' },
  { icon: 'src/images/rajasthan.webp', text: 'Rajasthan', link: '#' },
  { icon: 'src/images/sports.webp', text: 'Sports', link: '#' },
  { icon: 'src/images/lifestyle.webp', text: 'Life Style', link: '#' }
];



interface NewsStructure {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
  Gallery: string;
  category: string;
  tags: string;
  author: string;
}

interface CategoryInter {
  id: number;
  slug: string;
  name: string;
}


const SidebarPage = () => {
   const api = process.env.REACT_APP_API_URL as string;
    const [tags, setTags] = useState<CategoryInter[]>([]);
     useEffect(() => {
    fetchTags();
  }, []);

  const fetchTags = async () => {
    try {
      const res = await axios.get<CategoryInter[]>(`${api}/auth/category`);
      setTags(res.data);
    } catch (err) {
      console.error('Error fetching category:', err);
    }
  };

  
    const [newData, setNewData] = useState<NewsStructure[]>([]);
     useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<NewsStructure[]>(
            `${api}/auth/news`
          );
  
        
          setNewData(response.data);
          
        } catch (error) {
          // console.error("Post Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
  const [zodiacIndex, setZodiacIndex] = useState(0);
  const [galleryIndex, setGalleryIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setZodiacIndex((prev) => (prev + 1) % zodiacData.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setGalleryIndex((prev) => (prev + 1) % galleryImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full md:w-80 bg-gray-100 min-h-screen p-4 space-y-6">

      {/* Daily Astro */}
      <div className="bg-black text-white rounded-lg shadow-lg p-4 flex flex-col items-center">
        <span className="bg-red-500 text-white text-sm px-3 py-1 rounded-full mb-2 font-semibold">
          Daily Astro
        </span>
        <p className="text-sm mb-2">{formattedDate}</p>
        <img
          src={`${api}/${zodiacData[zodiacIndex].image}`}
          alt={zodiacData[zodiacIndex].sign}
          className="w-32 h-32 object-contain mb-4"
        />
        <span className="bg-red-600 text-white text-sm px-4 py-1 rounded-full font-bold mb-2">
          {zodiacData[zodiacIndex].sign}
        </span>
        <p className="text-xs text-center px-2">
          {zodiacData[zodiacIndex].description}
        </p>
      </div>

      {/* Gallery */}
      <div className="bg-white p-4 rounded shadow text-center">
        <h3 className="text-lg font-semibold mb-2">Gallery</h3>
       <Swiper
  modules={[Pagination]}
  pagination={{ clickable: true }}
  loop={true}
  spaceBetween={20}
  slidesPerView={1}
  className="w-full"
>
  {newData.map((item) => (
    <SwiperSlide key={item.id}>
      <img
        src={`${api}/${item.img}`}
        alt="gallery"
        className="rounded-md w-full h-[300px] object-cover"
      />
    </SwiperSlide>
  ))}
</Swiper>

        
      </div>

      {/* Category Menu */}
      <div className="bg-white p-4 rounded shadow grid grid-cols-2 gap-4">
        {tags.map((item, index) => (
          <a
            key={index}
            href={item.slug}
            className="flex flex-col items-center hover:scale-105 transition-transform"
          >
            
            <span className="text-sm font-medium hover:text-orange-600 transition-colors">
              {item.name}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SidebarPage;
